// api/Alarms

import request from '@utils/request'

const url = 'api/Alarms/'

/**
 *
 * 分页查询实时警报
 * @export
 * @param {*} data
 * @return {*}
 */
export function QueryAlarms (data) {
  return request({
    url: url + 'QueryAlarms',
    method: 'post',
    data
  })
}

/**
 *
 * 处理警报
 * @export
 * @param {*} data
 * @return {*}
 */
export function HandleAlarm (data) {
  return request({
    url: url + 'HandleAlarm',
    method: 'post',
    data
  })
}

/**
 *
 * 批删警报
 * @export
 * @param {*} data
 * @return {*}
 */
export function BatchDelAlarms (data) {
  return request({
    url: url + 'BatchDelAlarms',
    method: 'post',
    data
  })
}

/**
 *
 * 设置是否进行报警推送
 * @export
 * @param {*} data
 * @return {*}
 */
export function SwatchAlaramNotify (data) {
  return request({
    url: url + 'SwatchAlaramNotify',
    method: 'post',
    data
  })
}

/**
 *
 * 设置报警推送的手机号
 * @export
 * @param {*} data
 * @return {*}
 */
export function AlaramNotifySms (data) {
  return request({
    url: url + 'AlaramNotifySms',
    method: 'post',
    data
  })
}

/**
 *
 * 查询开关
 * @export
 * @param {*} data
 * @return {*}
 */
export function QuerySwitch (data) {
  return request({
    url: url + 'QuerySwitch',
    method: 'post',
    data
  })
}

/**
 *
 * 查询开关
 * @export
 * @param {*} data
 * @return {*}
 */
export function OpenSwitch (data) {
  return request({
    url: url + 'OpenSwitch',
    method: 'post',
    data
  })
}

/**
 *
 * 关闭开关
 * @export
 * @param {*} data
 * @return {*}
 */
export function CloseSwitch (data) {
  return request({
    url: url + 'CloseSwitch',
    method: 'post',
    data
  })
}

/**
 * 查询继电器各个通道状态
 * @param {*} data
 */
export function QueryChannelSwitch (data) {
  return request({
    url: url + 'QueryChannelSwitch',
    method: 'post',
    data
  })
}

/**
 * 查询继电器各个通道的指示灯状态
 * @param {*} data
 */
export function QueryChannelIndicator (data) {
  return request({
    url: url + 'QueryChannelIndicator',
    method: 'post',
    data
  })
}

/**
 * 1S闪闭功能 （关=>1S开=>关）
 * @param {*} data
 */
export function ChannelFlashOpen (data) {
  return request({
    url: url + 'ChannelFlashOpen',
    method: 'post',
    data
  })
}
